import React from "react";
import ToggleBlock from "../ToggleBlock";
import { Input, Label } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

function FormatFilter() {
    const formats = [
        'csv',
        'html',
        'json',
        'tablero'

    ]
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    function filter(format) {
        var queryParams = new URLSearchParams(window.location.search);
        if (queryParams.get('distribution__item__format') === format) {
            queryParams.delete('distribution__item__format');
        } else {
            queryParams.set("distribution__item__format", format);
        }
        window.history.replaceState(null, null, "?" + queryParams.toString());
        window.location.reload();
    }

    return (
        <div className="dc-search-facet-container">
            <ToggleBlock
                key={'formats'}
                title={'Formatos'}
                headingClasses={'sidenav-item sidenav-item-dropdown facet-block-format-inner'}
                innerClasses={'inner-fortmat-facets'}
                defaultClosed={true}
            >
                <div className="show-more-wrapper">
                    <ul className="show-more-container">
                        {formats.map((format) => {
                            var key = ""
                                .concat("formato-")
                                .concat(format, "-")
                                .concat(Math.random() * 100);
                            var checked = urlParams.get('distribution__item__format') === format
                            return (<li className="dc-facet-option">
                                <Input
                                    id={key}
                                    checked={checked}
                                    name={'formato'}
                                    type={'checkbox'}
                                    value={format}
                                    onChange={() => filter(format)} />
                                <Label
                                    htmlFor={key}
                                    className={'sidenav-item'}>
                                    <FontAwesomeIcon
                                        icon={["fas", checked ? "check-square" : "square"]}
                                        size={'1x'}
                                        role="presentation"
                                    />
                                    {format.toLocaleUpperCase()}
                                </Label>

                            </li>)
                        })}
                    </ul>
                </div>
            </ToggleBlock>
        </div>
    )
}

export default FormatFilter 